import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { AppFrame } from "../components/Layout";
import { EDITEUR, HEBERGEUR } from "../data/staticData";

function Section({ title, children }) {
  return (
    <div className="rounded-3xl border border-[#36302B]/6 bg-white p-5">
      <h2 className="font-display mb-2 text-[16px] font-medium text-[#36302B]">{title}</h2>
      {children}
    </div>
  );
}

const Line = ({ children }) => (
  <p className="text-[13.5px] leading-relaxed text-[#36302B]/70">{children}</p>
);

export default function MentionsLegales() {
  return (
    <AppFrame>
      <div className="px-6 pb-16">
        <div className="flex items-center gap-3 pt-7">
          <Link
            to="/"
            data-testid="legal-home-link"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-sm"
          >
            <ArrowLeft size={20} color="#36302B" />
          </Link>
          <h1 className="font-display text-3xl font-medium text-[#36302B]">Mentions légales</h1>
        </div>

        <p className="mt-4 text-[12.5px] leading-relaxed text-[#36302B]/55">
          Informations légales de l'application Renaître, conformément à la loi n° 2004-575 du 21 juin 2004
          pour la confiance dans l'économie numérique (LCEN).
        </p>

        <div className="mt-4 space-y-3">
          <Section title="Éditeur">
            <Line>{EDITEUR.nom}</Line>
            <Line>{EDITEUR.adresse}</Line>
            <Line>{EDITEUR.cpVille}</Line>
            <Line>{EDITEUR.siret}</Line>
            <a href={`mailto:${EDITEUR.email}`} className="text-[13.5px] font-semibold text-[#C57B67]">
              {EDITEUR.email}
            </a>
          </Section>

          <Section title="Directrice de la publication">
            <Line>{EDITEUR.nom}</Line>
          </Section>

          <Section title="Hébergeur">
            <Line>{HEBERGEUR.nom}</Line>
            <Line>{HEBERGEUR.adresse}</Line>
            <a href={`mailto:${HEBERGEUR.contact}`} className="text-[13.5px] font-semibold text-[#C57B67]">
              {HEBERGEUR.contact}
            </a>
          </Section>

          <Section title="Données personnelles">
            <Line>
              Renaître place la confidentialité au cœur de son fonctionnement. Vos données de santé (humeurs,
              résultats du test d'Édimbourg, terme de naissance) sont stockées exclusivement sur votre appareil :
              Renaître n'y a pas accès.
            </Line>
            <Link to="/privacy-policy" data-testid="legal-to-privacy" className="mt-2 inline-block text-[13.5px] font-semibold text-[#C57B67]">
              Voir la politique de confidentialité →
            </Link>
          </Section>

          <Section title="Transfert de données (États-Unis / Inde)">
            <Line>
              Les données techniques non sensibles peuvent être hébergées par Emergent Labs Inc. (États-Unis et
              Inde). Ces transferts sont encadrés par les clauses contractuelles types approuvées par la
              Commission Européenne. Les données de santé ne transitent jamais par ces serveurs.
            </Line>
          </Section>

          <Section title="Propriété intellectuelle">
            <Line>
              L'ensemble des contenus de l'application (textes, illustrations, marques) est protégé par le droit
              d'auteur. Les fiches d'information citent leurs sources (HAS, SOS Préma, Ameli, Service-Public.fr, etc.).
            </Line>
          </Section>

          <Section title="Contact">
            <a href={`mailto:${EDITEUR.email}`} className="text-[13.5px] font-semibold text-[#C57B67]">
              {EDITEUR.email}
            </a>
          </Section>
        </div>

        <p className="mt-6 text-center text-[11.5px] leading-relaxed text-[#36302B]/45">
          Renaître est un outil de bien-être et ne remplace pas un avis médical.
        </p>
      </div>
    </AppFrame>
  );
}
